// Avatar con iniziali fallback e indicatore stato
import { cn, getAvatarColor, getInitials } from '../../lib/utils'

interface AvatarProps {
  name: string
  src?: string | null
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  online?: boolean
  className?: string
}

const SIZE_CLASSES = {
  xs: 'h-6 w-6 text-xs',
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-16 w-16 text-lg',
}

const INDICATOR_SIZES = {
  xs: 'h-1.5 w-1.5',
  sm: 'h-2 w-2',
  md: 'h-2.5 w-2.5',
  lg: 'h-3 w-3',
  xl: 'h-3.5 w-3.5',
}

export function Avatar({ name, src, size = 'md', online, className }: AvatarProps) {
  const initials = getInitials(name)
  const bgColor = getAvatarColor(name)

  return (
    <div className={cn('relative inline-flex shrink-0', className)} aria-label={name}>
      {src ? (
        <img
          src={src}
          alt={name}
          className={cn('rounded-full object-cover', SIZE_CLASSES[size])}
        />
      ) : (
        <div
          className={cn('flex items-center justify-center rounded-full font-semibold text-white', SIZE_CLASSES[size])}
          style={{ backgroundColor: bgColor }}
          aria-hidden="true"
        >
          {initials}
        </div>
      )}
      {online !== undefined && (
        <span
          className={cn(
            'absolute bottom-0 right-0 rounded-full border-2 border-[var(--fc-surface)]',
            INDICATOR_SIZES[size],
            online ? 'bg-[var(--fc-success)]' : 'bg-[var(--fc-gray-400)]'
          )}
          aria-label={online ? 'Online' : 'Offline'}
        />
      )}
    </div>
  )
}
